import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { AtSymbolIcon } from "@heroicons/react/24/outline";

export default function ContactUs({ open, onClose }: { open: boolean; onClose: () => void }) {
	return (
		<Transition.Root show={open} as={Fragment}>
			<Dialog as="div" className="relative z-50" onClose={onClose}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0">
					<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
				</Transition.Child>

				<div className="fixed inset-0 z-50 overflow-y-auto">
					<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
							<Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
								<div>
									<div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-cary-100">
										<AtSymbolIcon className="h-6 w-6 text-cary-400" aria-hidden="true" />
									</div>
									<div className="mt-3 text-center sm:mt-5">
										<Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
											Contact Us
										</Dialog.Title>
										<div className="mt-2">
											<p className="text-sm text-gray-500">
												Questions &amp; comments can be directed to Han Lab.
												<br />
												Email:{" "}
												<a href="mailto:hanlab@caryinstitute.org" className="text-cary-500 font-bold">
													hanlab@caryinstitute.org
												</a>
												.
											</p>
										</div>
									</div>
								</div>
								<div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
									<a
										href="mailto:hanlab@caryinstitute.org"
										className="inline-flex w-full justify-center rounded-md border border-transparent bg-cary-400 px-4 py-2 text-base font-medium text-white opacity-80 shadow-sm hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-cary-300 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
										target="_BLANK"
										rel="noreferrer">
										Email Us
									</a>
									<button
										type="button"
										className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-cary-300 focus:ring-offset-2 sm:col-start-1 sm:mt-0 sm:text-sm"
										onClick={onClose}>
										Close
									</button>
								</div>
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	);
}
